'use strict';

angular.module('mean.admin-panel').controller('TradeAdminUsersController', ['$scope', '$timeout', 'CombinationService', 'Users', 'Global', 'MeanUser', '$filter', 'toaster', '$q', 'AdminPanel', 'tradeCodeService', 'userService', '$location',
    function ($scope, $timeout, CombinationService, Users, Global, MeanUser, $filter, toaster, $q, AdminPanel, tradeCodeService, userService, $location) {
        $scope.global = Global;
        $scope.package = {
            name: 'admin-panel'
        };
        $scope.main_account = null;
        var array = MeanUser.user.username.split('', 9);

        $scope.sortType = ['username'];
        $scope.sortReverse = false;

        $scope.contractor_code = array[2] + array[3] + array[4];
        $scope.trade_code = array[0] + array[1];
        console.log('got the company code value: ' + $scope.contractor_code);

        for (var i = 0; i < MeanUser.user.roles.length; i++) {
            if (MeanUser.user.roles[i] === 'tm_admin') {
                $scope.tm_admin = true;
            }
        }

        if (!$scope.tm_admin) {
            toaster.pop('error', 'Admin Panel', 'You do not have the proper permissions for this page.');
            $location.path('home');
            return;
        }

        $scope.userSchema = [{
            title: 'Email',
            schemaKey: 'email',
            type: 'text',
            inTable: true
        }, {
            title: 'Name',
            schemaKey: 'name',
            type: 'text',
            inTable: true
        }, {
            title: 'Username',
            schemaKey: 'username',
            type: 'username',
            inTable: true
        }, {
            title: 'Roles',
            schemaKey: 'roles',
            type: 'select',
            options: [{
                name: 'Admin',
                code: 'tm_admin'
            }, {
                name: 'Office',
                code: 'tm_office'
            }, {
                name: 'Manager',
                code: 'tm'
            }, {
                name: 'Foreman',
                code: 'foreman'
            }, {
                name: 'Tradesman',
                code: 'tradesman'
            }],
            inTable: true
        }, {
            title: 'Password',
            schemaKey: 'password',
            type: 'password',
            inTable: false
        }, {
            title: 'Phone',
            schemaKey: 'phone',
            type: 'phone',
            inTable: true
        }, {
            title: 'Pay Rate',
            schemaKey: 'pay_rate',
            type: 'text',
            inTable: true
        }, {
            title: 'Active',
            schemaKey: 'active',
            type: 'boolean',
            inTable: true
        }, {
            title: 'Reset',
            schemaKey: 'need_password_reset',
            type: 'boolean',
            inTable: true
        }];

        $scope.user = {
            'contractor_code': $scope.contractor_code
        };

        $scope.options = [{
            name: 'Admin',
            code: 'tm_admin'
        }, {
            name: 'Office',
            code: 'tm_office'
        }, {
            name: 'Manager',
            code: 'tm'
        }, {
            name: 'Foreman',
            code: 'foreman'
        }, {
            name: 'Tradesman',
            code: 'tradesman'
        }]

        $scope.setUserRole = function (user) {
            var inlist = $filter('filter')($scope.options, { 'code': user.roles[0] }, true);
            if (inlist.length !== 1) {
                toaster.pop('error', 'User Role Error', 'Contact Admin.');
                return;
            }
            user.roles[0] = inlist[0].name
        };

        $scope.init = function () {
            userService.getMainAccount(MeanUser.user.username).then(function (main_account) {
                $scope.main_account = main_account;
            });
            if (!$scope.contractor_code) {
                toaster.pop('error', 'Admin Panel', 'Your request cannot be processed.');
                return;
            }

            $scope.getUserList();
        };

        $scope.getUserList = () => {
            Users.query({
                'trade': MeanUser.user.trade[0],
                'contractor_code': $scope.contractor_code
            }, function (users) {
                _.each(users, function (user) {
                    if (user.tos_agreement_date)
                        user.tos_agreement_date = new Date(user.tos_agreement_date);
                    $scope.setUserRole(user);
                });
                $scope.users = users;
            });
        };

        $scope.saveCombination = (user, index) => {
            console.log(user)
            var inlist = $filter('filter')($scope.options, { 'name': user.roles[0] }, true);
            if (inlist.length !== 1) {
                toaster.pop('error', 'User Role Error', 'Contact Admin.');
                return;
            }
            user.roles[0] = inlist[0].code
            user.isEditable = false;
            user.comb = '';
            user.$update();
            $timeout(function () {
                $scope.getUserList();
            }, 0)
        };

        $scope.selectionCombination = function () {
            console.log($scope.example14model);
        };
        $scope.add = function () {
            if (!$scope.users) $scope.users = [];

            var user = new Users({
                email: $scope.user.email,
                name: $scope.user.name,
                username: userService.generateId($scope.users, $scope.trade_code, $scope.contractor_code),
                password: $scope.user.password,
                confirmPassword: $scope.user.password,
                roles: $scope.user.roles.code,
                trade: tradeCodeService.getName($scope.trade_code),
                contractor_code: $scope.contractor_code,
                pay_rate: $scope.user.pay_rate,
                active: true,
                need_password_reset: true,
                phone: $scope.user.phone,
                combination: $scope.main_account.combination
            });

            user.$save(function (response) {
                $scope.setUserRole(response);
                toaster.pop('success', 'Admin Panel', 'User ' + response.name + ' added to database');
                $scope.users.push(response);

                $scope.user.name = '';
                $scope.user.username = '';
                $scope.user.email = '';
                $scope.user.password = '';
                $scope.user.roles = '';
                $scope.user.division_code = '';
                $scope.user.pay_rate = '';
                $scope.user.phone = '';
            }, function (error) {
                if (angular.isArray(error.data)) {
                    error.data.forEach(function (item) {
                        toaster.pop('error', 'Admin Panel', item.msg);
                    });
                } else {
                    if (error.data.msg) {
                        toaster.pop('error', 'Admin Panel', error.data.msg);
                    } else {
                        toaster.pop('error', 'Admin Panel', error.data);
                    }
                }
            });
        };

        $scope.update = function (user) {
            if (angular.isArray(user.roles)) {
                user.roles = user.roles[0].code;
            } else {
                user.roles = user.roles.code;
            }
            user.$update(function (response) {
                $scope.setUserRole(user);
                toaster.pop('success', 'User Admin Panel', 'User ' + response.name + ' has been updated');
            }, function (error) {
                toaster.pop('error', 'User Admin Panel', error);
            });
        };

        $scope.editRate = function (user) {
            user.rateEditing = true;
        };

        $scope.doneRateEditing = function (user) {
            if (!user.rateEditing) return;
            $scope.update(user)
            user.rateEditing = false;
        };

        $scope.resetPassword = function (user) {
            $scope.user_to_change = user;
        };

        $scope.acceptNewPassword = function () {
            $scope.user_to_change.password =
                $scope.user_to_change.confirmPassword = this.new_user_password;

            MeanUser.resetForUser($scope.user_to_change);
        };
    }
]);



// WEBPACK FOOTER //
// ./packages/custom/admin-panel/public/controllers/tradeAdminUsers.js